// src/pages/CourseDetails.js

import React from 'react';
import { useParams } from 'react-router-dom';
import './CourseDetails.css';

const courseData = [
  {
    title: 'Foundation Course of Vedic Astrology',
    slug: 'foundation-vedic-astrology',
    description:
        'A beginner-friendly Vedic astrology course covering the basics of planets, houses, Rashis, Nakshatras, and simple prediction techniques to build a strong foundation for further advanced studies.',
      topics: [
        'Introduction to Vedic Astrology and its Principles',
        'Understanding the 9 Planets and their Significance',
        '12 Zodiac Signs and 12 Houses with their Meanings',
        'Nakshatras and their Role in Predictions',
        'Basics of Chart Reading and Planetary Strengths',
        'Introduction to Yogas and Simple Prediction Techniques'
      ],
      benefits: [
        'Understand the basic concepts of Vedic astrology',
        'Learn the role of planets, houses, and signs in predictions',
        'Start reading and interpreting simple birth charts',
        'Prepare for advanced Vedic astrology courses',
        'Gain confidence in analyzing personal and family charts'
      ],
    whoShouldJoin: 'Beginners who want to start their astrology journey.',
    certification: 'Certificate of Completion from [Your Academy Name]',
    originalPrice: 20000,
    offerPrice: 11000,
    duration: '6 months',
    image: '/assets/course/Foundation-Course-of-Vedic-Astrology.jpeg',
  },


  {
    title: 'Detailed (Advanced) Course of Vedic Astrology',
    slug: 'advanced-vedic-astrology',
    description:
        'An in-depth advanced astrology program covering divisional charts, Dashas, planetary transits, and predictive methods for accurate life event analysis and professional astrology practice.',
      topics: [
        'Navamsa & Other Divisional Charts (D9, D10, D12, etc.)',
        'Dashas and Timing of Events (Vimshottari, Yogini, Ashtottari)',
        'Planetary Transits and Predictive Techniques',
        'Advanced Chart Interpretation and Life Event Predictions'
      ],
      benefits: [
        'Gain expertise in divisional charts and advanced astrology techniques',
        'Accurately predict life events using Dashas and planetary transits',
        'Develop confidence for professional astrology consultations',
        'Understand deeper planetary influences for precise readings',
        'Enhance skills with real-life case study practice'
      ],
    whoShouldJoin: 'Intermediate learners who have a foundation in astrology.',
    certification: 'Advanced Certificate from [Your Academy Name]',
    originalPrice: 40000,
    offerPrice: 20000,
    duration: '1 year',
    image: '/assets/course/Detailed-(Advanced)-Course-of-Vedic-Astrology.jpeg',
  },
 {
  title: 'Lal Kitab Foundation Course',
  slug: 'lal-kitab-foundation-course',
  description:
    'A beginner-friendly course to learn the unique Lal Kitab astrology system, focusing on karmic influences, planetary behavior, predictions, and practical remedies without complex Dasha or divisional charts.',
  topics: [
    'Module 1: Introduction to Lal Kitab System (History, Karmic Debts, Chart Format)',
    'Module 2: Understanding the 12 Houses (Special Characteristics & House Relationships)',
    'Module 3: Planetary Principles (Behavior in Houses, Friend/Enemy Planets, Benefic & Malefic Rules)',
    'Module 4: Planetary Combinations & Effects (Yogas, House-specific Results, Effects of Planets without Aspects)',
    'Module 5: Predictions Based on Kal Kitab (Step-by-step Prediction, Life Event Analysis: Career, Marriage, Health, Children)',
    'Module 6: Remedial Measures (Practical & Daily Remedies, Do’s & Don’ts of Kal Kitab)'
  ],
  benefits: [
    'Understand the unique concepts of Lal Kitab astrology',
    'Learn how to interpret planetary positions and karmic influences',
    'Make predictions without relying on complex Dasha systems',
    'Analyze career, marriage, health, and other key life aspects',
    'Apply effective Lal Kitab remedies for balance and harmony'
  ],
  whoShouldJoin: 'Beginners and astrology learners interested in Lal Kitab principles and practical remedies.',
  certification: 'Kal Kitab Foundation Certificate',
  originalPrice: 24000,
  offerPrice: 11000,
  duration: '24 Weeks (1 session per week, 1.5 hours each)',
  mode: 'Online',
  language: 'Hindi / English',
  level: 'Beginner',
  image: '/assets/course/Kal-Kitab-Foundation-Course.jpeg'
},

  {
  title: 'Lal Kitab Advanced Course',
  slug: 'lal-kitab-advanced-course',
  description:
    'An advanced course for astrology learners to master Lal Kitab chart analysis, karmic remedies, Varshphal, transits, and real-life case studies for professional consultation.',
  topics: [
    'Module 1: Advanced House-Wise Analysis (1st to 12th House Karma, House Relationships, Graha Position Effects)',
    'Module 2: Secrets of Red Book Remedies (Logic of Remedies, Time-bound Applications, Avoiding Negative Outcomes)',
    'Module 3: Karmic Debts & Paap Graha (Rinanubandh, Paap Graha Correction, Generational Curses, Saturn-Rahu-Mars Effects)',
    'Module 4: Varshphal (Annual Horoscope) (Casting & Interpreting Yearly Chart, Advanced Remedy Planning)',
    'Module 5: Graha Gochar and Transit Impact (Transit-based Predictions, Upcoming Challenges, Short-term Remedies)',
    'Module 6: Curse, Blessings & Hidden Enemies (Ancestral Curses, Spiritual Blocks, Hidden Enemy Identification)',
    'Module 7: Practical Case Studies & Assignments (Real-life Examples for Career, Marriage, Health, Remedies)',
    'Module 8: Ethics & Responsibility (When to Suggest Remedies, Client Karma, Free Will)'
  ],
  benefits: [
    'Gain mastery in advanced Lal Kitab chart reading and predictions',
    'Learn the science behind effective Lal Kitab remedies',
    'Understand karmic debts, curses, and generational patterns',
    'Apply Varshphal and Gochar techniques for precise yearly predictions',
    'Offer professional Lal Kitab consultations with confidence and ethics'
  ],
  whoShouldJoin: 'Learners who have completed Lal Kitab Foundation Course or have equivalent knowledge.',
  certification: 'Lal Kitab Advanced Practitioner Certificate',
  originalPrice: 40000,
  offerPrice: 21000,
  duration: '24 Weeks (1 session per week, 90 mins each)',
  mode: 'Online',
  language: 'Hindi / English',
  level: 'Advanced',
  preRequisite: 'Lal Kitab Foundation Course or equivalent knowledge',
  image: '/assets/course/Lal-Kitab-Advanced-Course.jpeg'
},


  {
  title: 'Bhrighu Nandi Nadi Foundation Course',
  slug: 'bhrighu-nandi-nadi-foundation-course',
  description:
    'A complete beginner-friendly course on Bhrighu Nandi Nadi Astrology, teaching how to read charts, analyze planetary karakatwas, and make predictions without dasha or divisional charts.',
  topics: [
    'Module 1: Introduction to Nadi Astrology (Types of Nadis, Bhrighu Nandi Nadi uniqueness, Difference from Traditional Astrology)',
    'Module 2: Basics of BNN Philosophy (Rishi Vision, Planetary Karakatwas, Rashi Chart & Transit)',
    'Module 3: Core Principles of BNN (Static & Dynamic Charts, Conjunctions, Dispositors, Aspects)',
    'Module 4: Planetary Karakatwas (Significations of Sun, Moon, Mars, Mercury, Jupiter, Venus, Saturn, Rahu & Ketu)',
    'Module 5: Chart Reading Techniques – I (Step-by-step approach, Past/Present/Future, Simple Transit Predictions)',
    'Module 6: Transit (Gochar) in BNN (Importance, Double Transit, Timing Events)',
    'Module 7: Chart Reading Techniques – II (Case Studies on Career, Marriage, Health, Children)',
    'Module 8: Remedies and Ethics in BNN (Energy Correction, Karma Alignment, Practical Guidance)'
  ],
  benefits: [
    'Understand the core principles of BNN astrology',
    'Learn to read birth charts using karakatwas and transits',
    'Make accurate predictions without dasha and divisional charts',
    'Apply practical techniques to real-life case studies',
    'Learn remedies based on energy alignment and ethical practices'
  ],
  whoShouldJoin: 'Beginners and astrology enthusiasts looking to learn predictive astrology in a simple and practical way without complex calculations.',
  certification: 'Bhrighu Nandi Nadi Foundation Certificate',
  originalPrice: 12000,
  offerPrice: 5000,
  duration: '20 Sessions (1 session per week)',
  mode: 'Online',
  language: 'Hindi / English',
  level: 'Beginner',
  image: '/assets/course/Bhrighu-Nandi-Nadi-Foundation-Course.jpeg'
},

{
  title: 'Advanced Bhrighu Nandi Nadi Astrology Course',
  slug: 'advanced-bhrighu-nandi-nadi-astrology-course',
  description:
    'An advanced course designed to master predictive techniques in BNN Astrology, covering deep planetary karakatwas, transits, event timing, and advanced life-event prediction tools.',
  topics: [
    'Module 1: Advanced Karakatwa and Planetary Behavior (Conditional Karakatwas, Planetary Echo, Rashi vs Nakshatra vs Pada)',
    'Module 2: Advanced Transit Technique (Lagna, Moon & Sun transit, Triple Transit, Event Confirmation, Timing Tools)',
    'Module 3: Advanced Event Timing Techniques (Marriage, Career, Health, Litigation, Childbirth)',
    'Module 4: Advanced Planetary Linking Techniques (Cross-Horoscope Linking, Chain of Planets, Repetition Principle, Karma Tracing)',
    'Module 5: Predicting Life Events with BNN Precision (Marriage, Career, Health, Litigation, Spiritual Indicators)',
    'Module 6: Advanced Chakras in BNN (Event Activation & Timing through Chakras)',
    'Module 7: Advanced Use of Retrograde and Combust Planets (Hidden Karma, Backlog, Past-life Indicators)'
  ],
  benefits: [
    'Master advanced predictive techniques in BNN Astrology',
    'Accurately time life events like marriage, career shifts, and health issues',
    'Understand conditional karakatwas and advanced planetary behavior',
    'Apply triple transit and linking techniques for precise predictions',
    'Decode hidden karmic patterns using retrograde and combust planets'
  ],
  whoShouldJoin: 'Students who have completed the BNN Foundation Course or have equivalent knowledge in Nadi astrology.',
  certification: 'Advanced Bhrighu Nandi Nadi Astrology Certificate',
  originalPrice: 40000,
  offerPrice: 18000,
  duration: '40 Weeks (1 session per week)',
  mode: 'Online',
  language: 'Hindi / English',
  level: 'Advanced',
  preRequisite: 'BNN Foundation Course or equivalent knowledge',
  image: '/assets/course/Advanced-BNN-Astrology-Course.jpeg'
},

{
  title: 'Numerology Foundation & Advanced Course',
  slug: 'numerology-course',
  description:
    'Learn the history, significance, and practical applications of numerology, including core numbers, life path analysis, name corrections, compatibility, and advanced predictive techniques with remedies.',
  topics: [
    'Module 1: Introduction to Numerology (Origin, History, Number Vibrations, Importance of Name & DOB)',
    'Module 2: Core Numbers and Their Meanings (1-9, Master Numbers 11,22,33, Karmic Numbers 13,14,16,19)',
    'Module 3: Birth Date Analysis (Life Path, Birthday, Personal Year Numbers)',
    'Module 4: Name Numerology (Destiny Number, Personality Number)',
    'Module 5: Compatibility & Relationships (Relationship, Business, Child-Parent, Challenge Numbers, Life Transitions)',
    'Module 6: Personal Year, Month & Day Cycles (Monthly/Daily Forecasts, Decision Timing)',
    'Module 7: Name Correction Techniques (Balanced Names, Vowel-Consonant Vibrations)',
    'Module 8: Advanced Predictive Techniques (Future Events, Peak Years, Missing Numbers)',
    'Module 9: Business, Career & Finance Numerology (Business Names, Lucky Dates, Career Selection)',
    'Module 10: Remedies & Rectifications (Number-based Remedies, Yantra, Mantra, Color Therapy, Gemstones)'
  ],
  benefits: [
    'Understand the fundamental and advanced concepts of numerology',
    'Analyze birth dates, core numbers, and personal cycles',
    'Correct names and analyze mobile numbers for positivity',
    'Predict future events and life transitions using numerology',
    'Apply remedies for harmony in personal and professional life'
  ],
  whoShouldJoin: 'Beginners and enthusiasts interested in learning numerology for personal growth, predictions, and remedies.',
  certification: 'Numerology Practitioner Certificate',
  originalPrice: 20000,
  offerPrice: 12000,
  duration: '15 Weeks (1 class per week)',
  mode: 'Online',
  language: 'Hindi / English',
  level: 'Beginner to Advanced',
  image: '/assets/course/Numerology-Course.jpeg'
},

{
  title: 'Horary Astrology (Prashna Kundali)',
  slug: 'horary-astrology-prashna-kundali',
  description:
    'A complete course on Prashna (Horary) Astrology, teaching how to answer questions accurately without birth details using Prashna Lagna, Moon, and advanced timing techniques.',
  topics: [
    'Module 1: Introduction to Prashna Shastra (Importance, Core Principles, Ethics of Use)',
    'Module 2: Setting Up the Prashna (When & How to Cast a Chart, Rules of Prashna Lagna)',
    'Module 3: Planetary Indicators in Prashna (Moon, Lagna, Strength, Retrograde & Combust Planets)',
    'Module 4: House-Wise Question Analysis (1st to 12th House Predictions in Prashna)',
    'Module 5: Timing of Events (Use of Dasha, Antardasha, Transits & Planetary Aspects)',
    'Module 6: Moon and Arudha in Prashna (Mind of Querent, Arudha Lagna Relevance)',
    'Module 7: Special Tools in Prashna (Ashtakavarga, Navamsa, Drekkana, Tajik Prashna, Yogas)',
    'Module 8: Applied Prashna Techniques (Medical, Marriage, Career, Travel, Missing Items, Legal Cases)'
  ],
  benefits: [
    'Learn to make accurate predictions without birth data',
    'Analyze questions using Prashna Lagna and Moon placement',
    'Master timing techniques using dasha, transit, and aspects',
    'Apply horary astrology to real-life queries like marriage, career, health, and legal matters',
    'Use advanced tools like Ashtakavarga, Navamsa, and Arudha Lagna in Prashna'
  ],
  whoShouldJoin: 'Astrology learners with basic Vedic Astrology knowledge, familiar with Rashis, Planets, Houses, and Nakshatras.',
  certification: 'Horary Astrology (Prashna Kundali) Practitioner Certificate',
  originalPrice: 18000,
  offerPrice: 12000,
  duration: '15 Weeks (1 class per week)',
  mode: 'Online',
  language: 'Hindi / English',
  level: 'Basic to Advanced',
  preRequisite: 'Basic Vedic Astrology knowledge required',
  image: '/assets/course/Horary-Astrology-Prashna-Kundali-Course.jpeg'
},

{
  title: 'Vastu Shastra Course',
  slug: 'vastu-shastra-course',
  description:
    'A complete basic to advanced course in Vastu Shastra, teaching the principles of energy alignment, space analysis, and practical remedies for homes, offices, plots, and commercial spaces.',
  topics: [
    'Module 1: Introduction to Vastu Shastra (Origin, History, Scientific & Spiritual Basis, Panchamahabhutas)',
    'Module 2: Vastu Purusha Mandala (Concept, Structure, Directions & Ruling Deities)',
    'Module 3: Understanding Directions (8 Cardinal + Intermediate Directions, Room Placement Effects)',
    'Module 4: Basic Residential Vastu (Bedroom, Kitchen, Bathroom, Puja Room – Do’s & Don’ts)',
    'Module 5: Vastu for Flats and Apartments (Challenges, Remedies, Entrance Analysis)',
    'Module 6: Plot Selection and Layout Planning (Shape, Slope, Soil Testing, Ideal Road Placement)',
    'Module 7: Vastu for Commercial Spaces (Shops, Offices, Factories, Hotels, Seating & Cash Counter Tips)',
    'Module 8: Vastu Remedies Without Demolition (Colors, Mirrors, Plants, Pyramids, Crystals, Element Balancing)',
    'Module 9: Integration with Astrology (Lagna, Dasha, Planetary Influence on Spaces)',
    'Module 10: Professional Ethics and Report Writing (Client Handling, Vastu Reports, Legal Boundaries)',
    'Bonus: Vastu with Numerology, Temple & Spiritual Vastu, Modern Architecture Alignment, Vastu for Interior Designers'
  ],
  benefits: [
    'Understand Vastu principles from basic to advanced level',
    'Analyze residential, commercial, and plot spaces effectively',
    'Apply practical Vastu remedies without demolition',
    'Integrate Vastu with Astrology and Numerology for better results',
    'Offer professional Vastu consultations and create detailed reports'
  ],
  whoShouldJoin: 'Beginners, astrology learners, interior designers, architects, and anyone interested in space energy alignment.',
  certification: 'Professional Vastu Shastra Consultant Certificate',
  originalPrice: 40000,
  offerPrice: 18000,
  duration: '6 Months (1 session per week)',
  mode: 'Online',
  language: 'Hindi / English',
  level: 'Basic to Advanced',
  image: '/assets/course/Vastu-Shastra-Course.jpeg'
}







];

function CourseDetails() {
  const { slug } = useParams();
  const course = courseData.find((item) => item.slug === slug);

  if (!course) {
    return <div className="course-details-container">Course not found</div>;
  }

  return (
    <div className="course-details-container">
      <div className="course-details-card">
        <h1>{course.title}</h1>
        <img src={course.image} alt={course.title} className="course-image-large" />
        <h2>Duration: {course.duration}</h2>
        <p className="course-description">{course.description}</p>

        <h3>What You’ll Learn:</h3>
        <ul>
          {course.topics.map((topic, i) => (
            <li key={i}>✅ {topic}</li>
          ))}
        </ul>

        <h3>Benefits:</h3>
        <ul>
          {course.benefits.map((b, i) => (
            <li key={i}>⭐ {b}</li>
          ))}
        </ul>

        <h3>Who Should Join:</h3>
        <p>{course.whoShouldJoin}</p>

        <h3>Certification:</h3>
        <p>{course.certification}</p>

        <div className="price-section">
          <p className="price-tag">Offer Price: ₹{course.offerPrice}</p>
          <p className="original-price">Original Price: ₹{course.originalPrice}</p>
        </div>

        <div className="button-group">
          <button onClick={() => window.location.href = `/buy/${encodeURIComponent(course.title)}/${course.offerPrice}`}>
            Buy Now
          </button>
          <button onClick={() => window.history.back()}>
            Back to Courses
          </button>
        </div>
      </div>
    </div>
  );
}

export default CourseDetails;
